import { Stack, Typography } from '@mui/material';
import { DonutChart, DonutChartProps } from './DonutChart';

type DonutChartWithTitleProps = {
  title: string;
  chartTitleText: string;
  data: DonutChartProps['data'];
};

export const DonutChartWithTitle = (props: DonutChartWithTitleProps) => {
  return (
    <Stack direction="column" gap="0.5rem" justifyContent="center">
      <Typography variant="h6" textAlign="center">
        {props.title}
      </Typography>
      <DonutChart data={props.data} chartTitleText={props.chartTitleText} />
    </Stack>
  );
};
